// extracted by mini-css-extract-plugin
export default {"box":"SetConstant_box__mPg2c","selectTitle":"SetConstant_selectTitle__ncv-j","title":"SetConstant_title__8TPYn","inputTitle":"SetConstant_inputTitle__aSvMs"};